import ActorCategoryTable from './ActorCategoryTable';

export default ActorCategoryTable;
